import React, { Component } from 'react';
import { connect } from 'react-redux';
import storeJs from 'store';
import ReduxToastr from 'react-redux-toastr';
import Jwt from '../utils/helpers/jwt';
import { SessionApi } from '../api';

class App extends Component {
  
  componentWillMount() {
    this.restoreSession();   
  }

  restoreSession() {
    const jtoken = storeJs.get('jwt');
    const { dispatch } = this.props;
    const { token, payload, expired, error } = new Jwt(jtoken).parse();
    if (!error && !expired) {
      dispatch({
        type: SessionApi.events.auth.actionSuccess,
        syncing: false, 
        data: { token, payload, expired, isAuthenticated: true }
      });
      dispatch(SessionApi.actions.user());
    } else if (expired) storeJs.remove('jwt');
  }

  render() {
    return (
      <div>
        <ReduxToastr
          timeOut={4000}
          preventDuplicates
          position="top-right"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar
        />
        {this.props.children}
      </div>
    );
  }
}

export default connect()(App);
